export default {
  default: () => import("/home/circleci/project/layouts/default.vue").then(m => m.default || m)
}